export default __webpack_public_path__ + "static/step8-9114813221e36ddf7f74f3fa87d22b9f.svg";